import { memo } from "react";
import { IconVolume, IconVolume2, IconVolumeOff } from "@tabler/icons-react";

import { Slider } from "@fragments";

import ControlButton from "./ControlButton";

/**
 * VolumeControl — mute chip that reveals a compact slider on hover/focus
 * (CSS-driven expansion, no extra state). In the portrait rail the slider
 * runs vertically, growing out below the chip.
 */
function VolumeControl({ volume, muted, onChangeVolume, onToggleMute, vertical = false }) {
    const effectiveVolume = muted ? 0 : volume;

    const VolumeIcon =
        effectiveVolume === 0 ? IconVolumeOff
            : effectiveVolume < 0.5 ? IconVolume2
                : IconVolume;

    return (
        <div className="player-volume" onClick={(event) => event.stopPropagation()}>
            <ControlButton label={muted ? "Ativar som (m)" : "Desativar som (m)"} onClick={onToggleMute}>
                <VolumeIcon />
            </ControlButton>

            <div className="player-volume__slider">
                <Slider
                    value={Math.round(effectiveVolume * 100)}
                    onChange={(_, value) => onChangeVolume(value / 100)}
                    min={0}
                    max={100}
                    step={1}
                    valueLabel="off"
                    aria-label="Volume"
                    orientation={vertical ? "vertical" : "horizontal"}
                />
            </div>
        </div>
    );
}

export default memo(VolumeControl);
